export const DEFAULT_LOWER_INDENT = 6;
export const DEFAULT_HIGHER_INDENT = 5;

export const DEFAULT_ACTIVE_BIN_INDENT = 5;

export const ACTIVE_BIN_INDEX = 30;
export const TOTAL_BINS_COUNT = 61;
